__turbopack_context__.v({
  "caption": "Caption-module-scss-module__eflRRW__caption",
});
